import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed, useRoute, useStore } from "@nuxtjs/composition-api";

import { useAmplitude, useBranchService, useI18n, useLinkService } from "@/composables";
import { useCreatorShop } from "@/store/creator-shop";
import { getProductDetailsStore } from "@/store/product-details";
import { getProductSetsStore } from "@/store/product-sets";
import { FLAG_PRICE_DROP_BADGE } from "@/utils/experiments/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSetProductTile',
  props: {
  shopProductId: {
    type: String,
    required: true,
  },
  giftGuideEventProps: {
    type: Object as PropType<{ [key: string]: string }>,
    required: false,
    default: null,
  },
},
  setup(__props) {

const props = __props;

const route = useRoute();
const store = useStore();
const i18n = useI18n();
const branch = useBranchService();
const linkService = useLinkService();
const amplitude = useAmplitude();



const productSetId = computed(() => {
  return route.value.params.id;
});

const product = computed(() => {
  const productDetailsId = getProductSetsStore(store).productSetProducts[props.shopProductId]?.productReferenceId ?? "";
  return getProductDetailsStore(store).productDetails[productDetailsId];
});

const percentChange = computed(() => {
  const oneHundred = 100;
  return Math.round(Number(product.value?.percentChange) * oneHundred);
});

const discountBadgingFlag = computed(() => {
  return FLAG_PRICE_DROP_BADGE;
});

const retailerProductId = computed(() => {
  return product.value?.catalogRetailerProductId;
});

const isRetailerProduct = computed(() => {
  return Boolean(product.value?.hasVariants && retailerProductId);
});

const price = computed(() => {
  const localPrice = product.value?.localPrice;
  const currency = product.value?.currency;
  const price = product.value?.price;

  if (localPrice && currency) {
    return Intl.NumberFormat(i18n.locale, { style: "currency", currency }).format(Number(localPrice));
  }
  if (price) {
    return Intl.NumberFormat(i18n.locale, { style: "currency", currency: "USD" }).format(Number(price));
  }
  return "";
});

const imageUrl = computed(() => {
  // Use the image from shopProducts response over productDetails as its more reliable
  return [getProductSetsStore(store).productSetProducts[props.shopProductId]?.imageUrl || product.value?.imageUrl];
});

const linkUrl = computed(() => {
  if (isRetailerProduct.value) {
    return linkService.getProductDetailsLink({
      productDetailsId: product.value?.id,
      productSetId: productSetId.value,
    });
  }

  const linkUrl = getProductSetsStore(store).productSetProducts[props.shopProductId]?.linkUrl;

  return linkService.getProductLink({
    url: linkUrl ?? "",
    page: "product-set-details",
    priceDropPercent: product.value?.percentChange,
  });
});

const onClick = () => {
  useCreatorShop().setReferringShopTab();
  amplitude?.sendExitEvent("/product-browser", {
    "product-id": product.value?.id ?? "",
    "advertiser-name": product.value?.advertiserName ?? "",
    "branch-journey-creative-name": branch.lastDisplayedBanner,
    "referring-component": amplitude?.getReferringComponentByPage(route.value.name ?? "", "product feed"),
    ...(isRetailerProduct && { "ltk-direct-platform": "shopify" }),
    url: linkUrl.value ?? "",
    "is-gift-guide": false,
  });
};

return { __sfc: true,route, store, i18n, branch, linkService, amplitude, props, productSetId, product, percentChange, discountBadgingFlag, retailerProductId, isRetailerProduct, price, imageUrl, linkUrl, onClick }
}

})